import { useState, useEffect } from 'react'

import Container from './styles'

export default function NumberSelector({
  initial = 0,
  min = 0,
  max,
  onChange,
}) {
  const [value, setValue] = useState(initial)

  useEffect(() => {
    setValue(initial)
  }, [initial])

  function handleChange(op) {
    if (op === 'sub' && value === min) {
      setValue(min)
      return onChange(min)
    }

    if (op === 'sum' && max && value === max) {
      setValue(max)
      return onChange(max)
    }

    if (op === 'sub') {
      const newValue = value - 1
      setValue(newValue)
      return onChange(newValue)
    }

    if (op === 'sum') {
      const newValue = value + 1
      setValue(newValue)
      return onChange(newValue)
    }
  }

  return (
    <Container>
      <button onClick={() => handleChange('sub')}>-</button>
      <span className="value">{value}</span>
      <button onClick={() => handleChange('sum')}>+</button>
    </Container>
  )
}
